import { Link, useLocation } from "react-router-dom";
import { EllipsisMenu } from "../utils/ellipsis_menu";
import { makeModal } from "../utils/make_modal";
import { Offcanvas } from "react-bootstrap";
import { useApiMutation } from "../utils/api";
import { Field, Formik } from "formik";

const useSettingsModal = () =>
  makeModal(({ close, object }) => {
    const { put, saving } = useApiMutation();

    const update = (values: any) => {
      console.log("values", values);
      console.log("object", object);
      put(object._path, { project: values }).success(close);
    };

    return (
      <Offcanvas show={!!object} onHide={close} placement="end" size="lg">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Project Settings</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Formik initialValues={{ name: object.name }} onSubmit={update}>
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Project Name</label>
                  <Field name="name" className="form-control" />
                </div>
                <button type="submit" className="btn btn-primary" disabled={saving}>
                  Save
                </button>
              </form>
            )}
          </Formik>
        </Offcanvas.Body>
      </Offcanvas>
    );
  });

export const ProjectHeader = ({
  project,
  refetch,
}: {
  project: any;
  refetch: () => void;
}) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const SettingsModal = useSettingsModal();

  const links = [
    { path: "pages", label: "Pages" },
    { path: "notes", label: "Notes" },
    { path: "search", label: "Search" },
    {
      path: "discover",
      label: (
        <>
          Discover
          <i className="bi bi-stars ml-1" />
        </>
      ),
    },
  ];
  return (
    <div className="d-flex align-items-baseline mb-6">
      <h1>{project.name}</h1>

      <div className="ml-10 d-flex align-items-baseline">
        {links.map(({ path, label }) => {
          const isActive = currentPath.includes(path);
          const linkStyle = `mh-4 ${isActive ? "fw-bold black fs-22" : "gray"}`;

          return (
            <Link key={path} to={`/projects/${project.id}/${path}`} className={linkStyle}>
              {label}
            </Link>
          );
        })}
        <EllipsisMenu
          className="ml-3"
          actions={[{ label: "Settings", action: () => SettingsModal.set(project) }]}
        />
      </div>

      <SettingsModal refetch={refetch} />
    </div>
  );
};
